module.exports = __webpack_public_path__ + "img/schoolLogo-cy.8d759a0c.svg";